export default {"src":"/_next/static/media/maestro-light-noborder.5a81a5e2.svg","height":24,"width":36};